import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
// import VConsole from 'vconsole';

// if (process.env.REACT_APP_VCONSOLE === 'true') {
//   // eslint-disable-next-line @typescript-eslint/no-unused-vars
//   const vcon = new VConsole();
// }

ReactDOM.render(<App />, document.getElementById('root'))
